module.exports = __webpack_public_path__ + "img/b5.b08bf02e.png";